module.exports = __webpack_public_path__ + "img/sanqi2.14b8abc7.png";